<template>
  <div class="dean-text-area-container">
    <div class="row">
      <div class="small-4 medium-4 large-4 hd-4 columns" v-if="!hideLabel">
        <label :for="id" class="text-area-label">
          {{ label }}
          <span v-if="requiredField" class="required-field">
            *
          </span>
        </label>
      </div>
      <div :class="{ 'small-8 medium-8 large-8 hd-8 columns': !hideLabel, 'small-12 medium-12 large-12 hd-12 columns': hideLabel}">
        <textarea :id="id"
                  :class="textAreaClass"
                  :value="value"
                  @input="valueChanged"
                  @focus="$emit('focus')"
                  @blur="$emit('blur')"
                  :disabled="disabled"
                  :placeholder="placeholder"
                  :rows="rows"
                  :minlength="minLength"
                  :maxLength="maxLength"
                  :tabindex="tabIndex"
                  style="width: 100%; max-width: 100%;">
        </textarea>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue} from 'vue-property-decorator';

  @Component({})
  export default class deanTextArea extends Vue {
    // PROPS
    @Prop({default: ''}) protected value!: string;
    @Prop({default: false}) protected disabled!: boolean;
    @Prop({default: false}) protected warning!: boolean;
    @Prop({default: false}) protected requiredField!: boolean;
    @Prop({default: ''}) protected label!: string;
    @Prop({default: ''}) protected placeholder!: string;
    @Prop({default: ''}) protected validation!: string;
    @Prop({default: ''}) protected id!: string;
    @Prop() protected tabIndex!: number;
    @Prop({default: '5'}) protected rows!: string;
    @Prop() protected maxLength?: string;
    @Prop() protected minLength?: string;
    @Prop({default: false}) protected hideLabel!: boolean;

    get textAreaClass() {
      let textClass = 'dean-text-area';
      if (this.warning) {
        textClass += ' warning';
      }
      return textClass;
    }

    public valueChanged(value: any) {
      this.$emit('input', value.target.value);
    }
  }
</script>

<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  .dean-text-area-container {
    padding: 5px 10px;

    .text-area-label {
      padding-left: 10px;
    }

    .required-field {
      color: var(--color-info-danger, $color-info-danger);
    }

    .dean-text-area {
      border-radius: 5px;
      border: 1px solid var(--color-light-shade-1, $color-light-shade-1);
      padding: 5px;
      @include transition(all ease 0.8s);

      &:focus {
        outline: none;
        background-position: left bottom;
        box-shadow: 0 0 10px 2px var(--color-secondary, $color-secondary);
      }

      &.warning {
        border: 1px solid var(--color-info-warning, $color-info-warning);
      }
    }
  }
</style>
